import PropTypes from 'prop-types'
import React from 'react'
import PuxIcon from 'Shared/components/PuxIcon/PuxIcon'
import PuxLink from 'Shared/utils/PuxLink'

import {
  handleLinkClick,
  handleStrippedLinkClick,
  stripHashedLocation,
} from './puxAnchorUtils'

PuxAnchorLink.propTypes = {
  to: PropTypes.string.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  stripHash: PropTypes.bool,
  gatsbyLinkProps: PropTypes.object,
  onAnchorLinkClick: PropTypes.func,
  iconName: PropTypes.string,
  iconSize: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([`tiny`, `small`, `medium`, `large`]),
  ]),
  children: PropTypes.node,
}

export function PuxAnchorLink({
  to,
  title,
  children,
  className,
  stripHash = false,
  gatsbyLinkProps = {},
  onAnchorLinkClick,
  iconName,
  iconSize,
}) {
  const onClickHandler = stripHash ? handleStrippedLinkClick : handleLinkClick
  const linkProps = {
    ...gatsbyLinkProps,
    /**
     * Spread optional gatsbyLinkProps object in fist, so our specific props will override
     */
    to: stripHash ? stripHashedLocation(to) : to,
    onClick: (e) => onClickHandler(to, e, onAnchorLinkClick),
  }

  /**
   * Optional props
   */
  if (title) linkProps.title = title
  if (className) linkProps.className = className

  return (
    <PuxLink {...linkProps}>
      {children ? children : title}
      {iconName ? <PuxIcon name={iconName} size={iconSize} decorative /> : null}
    </PuxLink>
  )
}
